import React from "react";
import {
  AbsoluteFill,
  interpolate,
  spring,
  useCurrentFrame,
  useVideoConfig,
} from "remotion";

// ─── TEMA 1: NEO-BRUTALIST STREETWEAR (ACID Y2K) ───────────────────────────
export const KyuStoreFlashSaleNeoBrutalist: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  // Animasi spring
  const titleSpring = spring({
    frame,
    fps,
    config: { damping: 14, stiffness: 180, mass: 0.8 },
  });

  const card1Spring = spring({
    frame: frame - 10,
    fps,
    config: { damping: 15, stiffness: 160 },
  });

  const card2Spring = spring({
    frame: frame - 20,
    fps,
    config: { damping: 15, stiffness: 160 },
  });

  const chatSpring = spring({
    frame: frame - 30,
    fps,
    config: { damping: 16, stiffness: 150 },
  });

  return (
    <AbsoluteFill
      style={{
        backgroundColor: "#0d1814",
        color: "#ffffff",
        fontFamily: "'Space Grotesk', sans-serif, system-ui",
        padding: "60px 48px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        boxSizing: "border-box",
      }}
    >
      {/* Background Accent Grid & Shapes */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage:
            "radial-gradient(#e8f36e 1px, transparent 1px), radial-gradient(#1e3b31 1px, #0d1814 1px)",
          backgroundSize: "40px 40px",
          backgroundPosition: "0 0, 20px 20px",
          opacity: 0.15,
          pointerEvents: "none",
        }}
      />

      {/* HEADER SECTION */}
      <div style={{ position: "relative", zIndex: 10 }}>
        {/* Brand Tagline Top */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "32px",
          }}
        >
          <div
            style={{
              backgroundColor: "#e8f36e",
              color: "#0d1814",
              fontWeight: 900,
              fontSize: "24px",
              padding: "8px 20px",
              textTransform: "uppercase",
              letterSpacing: "-0.03em",
              borderRadius: "4px",
              border: "3px solid #ffffff",
              boxShadow: "4px 4px 0px #ffffff",
            }}
          >
            ⚡ JADWAL KERAMAT TOP UP
          </div>
          <div
            style={{
              color: "#e8f36e",
              fontWeight: 800,
              fontSize: "22px",
              letterSpacing: "0.05em",
            }}
          >
            KYUSTORE.COM
          </div>
        </div>

        {/* Main Big Punchy Title */}
        <div
          style={{
            transform: `scale(${titleSpring})`,
            transformOrigin: "left center",
          }}
        >
          <div
            style={{
              fontSize: "96px",
              fontWeight: 900,
              lineHeight: 0.9,
              letterSpacing: "-0.05em",
              color: "#ffffff",
              textTransform: "uppercase",
            }}
          >
            FLASH
          </div>
          <div
            style={{
              fontSize: "116px",
              fontWeight: 900,
              lineHeight: 0.9,
              letterSpacing: "-0.05em",
              color: "#e8f36e",
              textTransform: "uppercase",
              textShadow: "6px 6px 0px #13251f",
            }}
          >
            SALE!
          </div>
          <div
            style={{
              marginTop: "16px",
              fontSize: "30px",
              fontWeight: 700,
              color: "#a4c2b5",
              letterSpacing: "-0.02em",
            }}
          >
            JANGAN ASAL CHECKOUT SEBELUM TANGGAL INI 👇
          </div>
        </div>
      </div>

      {/* CENTER: CONVERSATION BUBBLE / OBROLAN SANTAI */}
      <div
        style={{
          position: "relative",
          zIndex: 10,
          display: "flex",
          flexDirection: "column",
          gap: "24px",
          transform: `translateY(${interpolate(chatSpring, [0, 1], [40, 0])}px)`,
          opacity: chatSpring,
        }}
      >
        {/* Chat Bubble 1 (Teman) */}
        <div
          style={{
            alignSelf: "flex-start",
            maxWidth: "85%",
            backgroundColor: "#162821",
            border: "3px solid #284b3e",
            borderRadius: "24px 24px 24px 4px",
            padding: "24px 28px",
            boxShadow: "6px 6px 0px rgba(0,0,0,0.4)",
          }}
        >
          <div style={{ color: "#a4c2b5", fontSize: "20px", fontWeight: 700, marginBottom: "8px" }}>
            👤 Teman 1
          </div>
          <div style={{ color: "#ffffff", fontSize: "28px", fontWeight: 700, lineHeight: 1.3 }}>
            "Woy lu mau top up? Tahan dulu jangan checkout sekarang!"
          </div>
        </div>

        {/* Chat Bubble 2 (Penasaran) */}
        <div
          style={{
            alignSelf: "flex-end",
            maxWidth: "85%",
            backgroundColor: "#203a30",
            border: "3px solid #3d6b59",
            borderRadius: "24px 24px 4px 24px",
            padding: "24px 28px",
            boxShadow: "6px 6px 0px rgba(0,0,0,0.4)",
          }}
        >
          <div style={{ color: "#e8f36e", fontSize: "20px", fontWeight: 700, marginBottom: "8px", textAlign: "right" }}>
            👤 Teman 2
          </div>
          <div style={{ color: "#ffffff", fontSize: "28px", fontWeight: 700, lineHeight: 1.3, textAlign: "right" }}>
            "Lah emang napa? Ada info apaan emangnya?"
          </div>
        </div>

        {/* Chat Bubble 3 (Spill Jadwal) */}
        <div
          style={{
            alignSelf: "flex-start",
            maxWidth: "90%",
            backgroundColor: "#e8f36e",
            color: "#0d1814",
            border: "4px solid #ffffff",
            borderRadius: "24px 24px 24px 4px",
            padding: "28px 32px",
            boxShadow: "8px 8px 0px #ffffff",
          }}
        >
          <div style={{ color: "#0d1814", fontSize: "20px", fontWeight: 900, marginBottom: "8px" }}>
            🔥 INFO RESMI KYU STORE
          </div>
          <div style={{ fontSize: "32px", fontWeight: 900, lineHeight: 1.25 }}>
            "Kyu Store pasti gelar FLASH SALE 2 KALI sebulan: Pertengahan & Akhir Bulan!"
          </div>
        </div>
      </div>

      {/* SCHEDULE CARDS DUA TANGGAL KERAMAT */}
      <div
        style={{
          position: "relative",
          zIndex: 10,
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "24px",
        }}
      >
        {/* Card 1: Pertengahan Bulan */}
        <div
          style={{
            backgroundColor: "#13251f",
            border: "4px solid #e8f36e",
            borderRadius: "16px",
            padding: "28px 24px",
            transform: `scale(${card1Spring})`,
            boxShadow: "6px 6px 0px #e8f36e",
          }}
        >
          <div
            style={{
              backgroundColor: "#203a30",
              color: "#e8f36e",
              fontSize: "18px",
              fontWeight: 800,
              padding: "6px 14px",
              borderRadius: "8px",
              display: "inline-block",
              marginBottom: "16px",
            }}
          >
            DROP 01
          </div>
          <div style={{ fontSize: "36px", fontWeight: 900, color: "#ffffff", lineHeight: 1.1 }}>
            PERTENGAHAN BULAN
          </div>
          <div style={{ fontSize: "22px", color: "#a4c2b5", fontWeight: 600, marginTop: "12px" }}>
            📅 Tanggal 14 - 16
          </div>
        </div>

        {/* Card 2: Akhir Bulan */}
        <div
          style={{
            backgroundColor: "#13251f",
            border: "4px solid #ffffff",
            borderRadius: "16px",
            padding: "28px 24px",
            transform: `scale(${card2Spring})`,
            boxShadow: "6px 6px 0px #ffffff",
          }}
        >
          <div
            style={{
              backgroundColor: "#ffffff",
              color: "#13251f",
              fontSize: "18px",
              fontWeight: 800,
              padding: "6px 14px",
              borderRadius: "8px",
              display: "inline-block",
              marginBottom: "16px",
            }}
          >
            DROP 02
          </div>
          <div style={{ fontSize: "36px", fontWeight: 900, color: "#e8f36e", lineHeight: 1.1 }}>
            AKHIR BULAN
          </div>
          <div style={{ fontSize: "22px", color: "#ffffff", fontWeight: 600, marginTop: "12px" }}>
            📅 Spesial Gajian
          </div>
        </div>
      </div>

      {/* FOOTER SAFE-ZONE (SAFE FROM BOTTOM 220PX) */}
      <div
        style={{
          position: "relative",
          zIndex: 10,
          borderTop: "2px dashed #284b3e",
          paddingTop: "24px",
          marginBottom: "120px", // safe margin above TikTok UI
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div style={{ fontSize: "22px", fontWeight: 700, color: "#a4c2b5" }}>
          🔔 Pasang Alarm & Reminder Sekarang
        </div>
        <div
          style={{
            backgroundColor: "#e8f36e",
            color: "#0d1814",
            padding: "12px 24px",
            borderRadius: "30px",
            fontWeight: 900,
            fontSize: "22px",
          }}
        >
          kyustore.com ➔
        </div>
      </div>
    </AbsoluteFill>
  );
};

// ─── TEMA 2: SWISS EDITORIAL PAPER (WARM PAPER & CLEAN SERIF) ──────────────
export const KyuStoreFlashSaleSwissPaper: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const titleSpring = spring({
    frame,
    fps,
    config: { damping: 20, stiffness: 120 },
  });

  const contentSpring = spring({
    frame: frame - 15,
    fps,
    config: { damping: 20, stiffness: 120 },
  });

  return (
    <AbsoluteFill
      style={{
        backgroundColor: "#f4f0e8",
        color: "#1a2421",
        fontFamily: "'Instrument Serif', 'Georgia', serif",
        padding: "70px 56px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        boxSizing: "border-box",
      }}
    >
      {/* Paper Texture Overlay */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage:
            "radial-gradient(#1a2421 0.75px, transparent 0.75px)",
          backgroundSize: "24px 24px",
          opacity: 0.08,
          pointerEvents: "none",
        }}
      />

      {/* EDITORIAL HEADER */}
      <div style={{ position: "relative", zIndex: 10 }}>
        {/* Masthead */}
        <div
          style={{
            borderBottom: "2px solid #1a2421",
            paddingBottom: "18px",
            marginBottom: "36px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "baseline",
            fontFamily: "sans-serif",
            textTransform: "uppercase",
            fontSize: "20px",
            letterSpacing: "0.15em",
            fontWeight: 700,
          }}
        >
          <div>Kyu Store Gazette</div>
          <div>Issue 02 / Routine Promo</div>
          <div>kyustore.com</div>
        </div>

        {/* Big Editorial Title */}
        <div
          style={{
            transform: `translateY(${interpolate(titleSpring, [0, 1], [30, 0])}px)`,
            opacity: titleSpring,
          }}
        >
          <div
            style={{
              fontSize: "105px",
              lineHeight: 0.95,
              fontWeight: 400,
              letterSpacing: "-0.03em",
              color: "#111d18",
            }}
          >
            The Flash Sale Calendar.
          </div>
          <div
            style={{
              marginTop: "20px",
              fontFamily: "sans-serif",
              fontSize: "26px",
              fontWeight: 500,
              color: "#50635b",
              lineHeight: 1.4,
              maxWidth: "90%",
            }}
          >
            Sebuah catatan penting buat gamer yang ingin menghemat pengeluaran top up rutin setiap bulannya.
          </div>
        </div>
      </div>

      {/* CONVERSATION EXCERPT / QUOTE BOX */}
      <div
        style={{
          position: "relative",
          zIndex: 10,
          backgroundColor: "#ebe5d8",
          borderLeft: "6px solid #1a2421",
          padding: "36px 40px",
          borderRadius: "0 16px 16px 0",
          transform: `translateY(${interpolate(contentSpring, [0, 1], [40, 0])}px)`,
          opacity: contentSpring,
        }}
      >
        <div
          style={{
            fontFamily: "sans-serif",
            fontSize: "18px",
            fontWeight: 800,
            color: "#6c8077",
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            marginBottom: "16px",
          }}
        >
          Obrolan Dua Sahabat
        </div>
        <div
          style={{
            fontSize: "36px",
            lineHeight: 1.35,
            fontStyle: "italic",
            color: "#111d18",
          }}
        >
          "Jangan buru-buru checkout dulu. Lu belum tahu ya kalau Kyu Store selalu adain Flash Sale tiap pertengahan sama akhir bulan?"
        </div>
      </div>

      {/* SCHEDULED DATES LIST (SWISS EDITORIAL GRID) */}
      <div
        style={{
          position: "relative",
          zIndex: 10,
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          fontFamily: "sans-serif",
        }}
      >
        {/* Item 1 */}
        <div
          style={{
            borderTop: "1.5px solid #1a2421",
            paddingTop: "24px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <div style={{ fontSize: "16px", fontWeight: 700, color: "#6c8077", letterSpacing: "0.1em" }}>
              PERIOD I
            </div>
            <div style={{ fontSize: "40px", fontWeight: 800, color: "#111d18", letterSpacing: "-0.02em" }}>
              Pertengahan Bulan
            </div>
          </div>
          <div
            style={{
              backgroundColor: "#111d18",
              color: "#f4f0e8",
              padding: "10px 24px",
              borderRadius: "24px",
              fontWeight: 700,
              fontSize: "20px",
            }}
          >
            Tanggal 15
          </div>
        </div>

        {/* Item 2 */}
        <div
          style={{
            borderTop: "1.5px solid #1a2421",
            borderBottom: "1.5px solid #1a2421",
            paddingTop: "24px",
            paddingBottom: "24px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <div style={{ fontSize: "16px", fontWeight: 700, color: "#6c8077", letterSpacing: "0.1em" }}>
              PERIOD II
            </div>
            <div style={{ fontSize: "40px", fontWeight: 800, color: "#111d18", letterSpacing: "-0.02em" }}>
              Akhir Bulan / Payday
            </div>
          </div>
          <div
            style={{
              backgroundColor: "#111d18",
              color: "#f4f0e8",
              padding: "10px 24px",
              borderRadius: "24px",
              fontWeight: 700,
              fontSize: "20px",
            }}
          >
            Spesial Gajian
          </div>
        </div>
      </div>

      {/* EDITORIAL FOOTER SAFE ZONE */}
      <div
        style={{
          position: "relative",
          zIndex: 10,
          marginBottom: "120px", // safe zone above TikTok/Reels UI
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontFamily: "sans-serif",
        }}
      >
        <div style={{ fontSize: "20px", color: "#50635b", fontWeight: 600 }}>
          Simpan informasi ini. Kunjungi kyustore.com tepat di tanggalnya.
        </div>
        <div style={{ fontSize: "22px", fontWeight: 800, color: "#111d18" }}>
          KYUSTORE.COM ➔
        </div>
      </div>
    </AbsoluteFill>
  );
};
